export function handleRightClick(event) {
  event.preventDefault();
}
